<template>
  <g v-if="hasSize" class="c-graph-frame">
    <rect
      class="c-graph-frame__rect"
      :x="rect.x"
      :y="rect.y"
      :height="rect.h"
      :width="rect.w"
    />
    <line
      v-if="hasLine"
      class="c-graph-frame__line"
      :x1="line.x1"
      :x2="line.x2"
      :y1="line.y"
      :y2="line.y"
    />
  </g>
</template>

<script>
export default {
  props: {
    hasLine: {
      type: Boolean,
      required: false
    },
    size: {
      type: Object,
      required: true
    }
  },

  computed: {
    line() {
      return {
        x1: 0,
        x2: this.size.canvasW,
        y: this.size.graph.bottom
      };
    },

    rect() {
      return {
        x: this.size.graph.left - this.size.frameW / 2,
        y: this.size.graph.top - this.size.frameW / 2,
        h: this.size.graphH + this.size.frameW,
        w: this.size.graphW + this.size.frameW
      };
    },

    hasSize() {
      return this.size.canvasH && this.size.canvasW;
    }
  }
};
</script>
